import {ColumnProps} from './../types/board.types';

export const BRD_HEADER_FAV_ADD = 'BRD_HEADER_FAV_ADD';
export const  BRD_HEADER_FAV_DEL = 'BRD_HEADER_FAV_DEL';
export const  BRD_UPDATE_BOARD_DATA = 'BRD_UPDATE_BOARD_DATA';

interface AddBoardFavData
{
    type: typeof BRD_HEADER_FAV_ADD,
    payload: ColumnProps
}

interface DelBoardFavData
{
    type: typeof BRD_HEADER_FAV_DEL,
    payload: ColumnProps
}

interface UpdateBoardHeaderData
{
    type: typeof BRD_UPDATE_BOARD_DATA,
    payload: ColumnProps
}

export type BorderHeaderActionTypes = AddBoardFavData | DelBoardFavData | UpdateBoardHeaderData;
